import {
  GetTeamMembers,
  GetRoles,
  CurrentUser,
  LoadUsers,
  LoadAssignees,
  UpdateUserLeadSchedule,
  UpdateUserAccess,
  UpdateUserProfile,
  ResolveInvitationLink,
  InviteUser,
  ActivateUser,
  DeactivateUser
} from './User.gql';
import { CreateUploadForm, AttachFileToQuote } from './Asset.gql';
import {
  GetQuote,
  FindPossibleDuplicates,
  PowerSearch,
  GetQuoteEvents,
  LoadQuotes,
  GetQuotesCount,
  RunTransportAutoQuoter,
  CreateQuote,
  UpdateQuote,
  DuplicateQuote,
  ConvertToQuote,
  SendQuoteEmail,
  SendTermsAndConditionsEmail,
  SendBillingInfoInputEmail,
  SendQuoteSMS,
  ResolveBookOrderLink,
  ResolveOrderSurveyLink,
  UpdateQuoteByCustomer,
  BatchUpdateQuotes
} from './Quote.gql';
import { GetFollowups, GetFollowupsCount } from './Followup.gql';
import {
  LoadOrders,
  GetOrdersCount,
  GetOrder,
  CreateOrder,
  UpdateOrder,
  PostToLoadBoard,
  RemoveFromLoadBoard,
  DuplicateOrder,
  ConvertToOrder,
  SetBillingInfoToOrder,
  ChargeOrder,
  DispatchOrder,
  ResolveTermsAndConditionsLink,
  ResolveBillingInformationLink,
  AcceptTermsAndConditions,
  ProvideBillingInfo,
  BatchUpdateOrders
} from './Order.gql';
import {
  GetEmailTemplate,
  GetEmailTemplates,
  CreateEmailTemplate,
  UpdateEmailTemplate,
  DeleteEmailTemplate
} from './EmailTemplate.gql';
import {
  GetSMSTemplate,
  GetSMSTemplates,
  CreateSMSTemplate,
  UpdateSMSTemplate,
  DeleteSMSTemplate
} from './SMSTemplate.gql';
import {
  GetVMAudioFiles
} from './VMAudioFiles.gql';
import {
  GetStatus,
  GetParentStatus,
  UpdateStatus,
  CreateStatus,
  DeleteStatus
} from './Status.gql';

import {
  GetVehicleSizes,
  GetVehicleSizechart,
  UpdateVehicleSizechart,
  DeleteVehicleSizechart,
  UpdateVehicleSize
} from './VehicleSize.gql';

import { AddQuoteNote, UpdateQuoteNote, DeleteQuoteNote } from './Note.gql';

import {
  GetMileagePricings,
  UpdateMileagePricings,
  DeleteMileagePricings
} from './MileagePricing.gql';

import {
  GetPricingExceptions,
  CreatePricingException,
  UpdatePricingException,
  UpdatePricingExceptions
} from './PricingException.gql';

import {
  GetCarrier,
  GetCarriers,
  AddCarrier,
  UpdateCarrier,
  AddDriver,
  UpdateDriver
} from './Carrier.gql';

import {
  GetDistanceFees,
  UpdateDistanceFees,
  DeleteDistanceFees
} from './Fee.gql';

import { GetPrimaryPhoneNumber, GetSecondaryPhoneNumber, GetAccountPhoneNumbers, SetPhoneNumber } from './Integration.gql';

import {
  GetNotificationsCount,
  GetTodayNotifications,
  GetEarlierNotifications,
  MarkNotificationAsRead,
  MarkTodayNotificationsAsRead,
  MarkEarlierNotificationsAsRead
} from './Notification.gql';

import {
  GetQuotesMonthlyTotals,
  GetUserQuotesDailyTotals,
  GetTodayTransactions,
  GetReferrerReport,
  GetReferrerReportWebsite,
  GetSalesReport,
  GetStatusReport,
  GetStatusOrdersReport,
  GetQuotesReportByReferrer,
  GetOrdersReportByReferrer,
  GetDispatchesReportByReferrer,
  GetQuotesReportByUser,
  GetOrdersReportByUser,
  GetDispatchesReportByUser
} from './Report.gql';

import {
  GetShortCodes,
  UpdateShortCodes,
  DeleteShortCodes
} from './ShortCode.gql';

import {
  GetMarketing,
  GetMarketings,
  UpdateMarketing,
  CreateMarketing,
  DeleteMarketing
} from './Marketing.gql';

import {
  GetReferrers,
  CreateReferrer,
  UpdateReferrer,
  DeleteReferrer
} from './Referrer.gql';


import {
  GetRemoteDispatchesForOrder,
  GetLoadBoardForOrder,
  GetRemoteDispatches
} from './RemoteDispatch.gql';

import {
  BasePriceFactors
} from './Pricing.gql';

import {
  SubmitCustomerSurvey,
  GetSurveys
} from './Survey.gql';

import {
  GetDistance,
  GetGeoLocation
} from './Map.gql';

export default {
  queries: {
    getTeamMembers: GetTeamMembers,
    getRoles: GetRoles,
    currentUser: CurrentUser,
    loadUsers: LoadUsers,
    loadAssignees: LoadAssignees,
    getEmailTemplate: GetEmailTemplate,
    getEmailTemplates: GetEmailTemplates,
    getSMSTemplate: GetSMSTemplate,
    getSMSTemplates: GetSMSTemplates,
    getVMAudioFiles: GetVMAudioFiles,
    getStatus: GetStatus,
    getParentStatus: GetParentStatus,
    powerSearch: PowerSearch,
    loadQuotes: LoadQuotes,
    getQuoteEvents: GetQuoteEvents,
    getQuotesCount: GetQuotesCount,
    getQuote: GetQuote,
    findPossibleDuplicates: FindPossibleDuplicates,
    getFollowups: GetFollowups,
    getFollowupsCount: GetFollowupsCount,
    getVehicleSizes: GetVehicleSizes,
    getMileagePricings: GetMileagePricings,
    getPricingExceptions: GetPricingExceptions,
    getVehicleSizechart: GetVehicleSizechart,
    loadOrders: LoadOrders,
    getOrdersCount: GetOrdersCount,
    getOrder: GetOrder,
    getCarrier: GetCarrier,
    getCarriers: GetCarriers,
    getDistanceFees: GetDistanceFees,
    getPrimaryPhoneNumber: GetPrimaryPhoneNumber,
    getSecondaryPhoneNumber: GetSecondaryPhoneNumber,
    getAccountPhoneNumbers: GetAccountPhoneNumbers,
    getTodayNotifications: GetTodayNotifications,
    getEarlierNotifications: GetEarlierNotifications,
    getNotificationsCount: GetNotificationsCount,
    getQuotesMonthlyTotals: GetQuotesMonthlyTotals,
    getUserQuotesDailyTotals: GetUserQuotesDailyTotals,
    getTodayTransactions: GetTodayTransactions,
    getShortCodes: GetShortCodes,
    getMarketing: GetMarketing,
    getMarketings: GetMarketings,
    getReferrers: GetReferrers,
    getReferrerReport: GetReferrerReport,
    getReferrerReportWebsite: GetReferrerReportWebsite,
    getSalesReport: GetSalesReport,
    getStatusReport: GetStatusReport,
    getStatusOrdersReport: GetStatusOrdersReport,
    getBasePriceFactors: BasePriceFactors,
    loadSurveys: GetSurveys,
    getQuotesReportByReferrer: GetQuotesReportByReferrer,
    getOrdersReportByReferrer: GetOrdersReportByReferrer,
    getDispatchesReportByReferrer: GetDispatchesReportByReferrer,
    getQuotesReportByUser: GetQuotesReportByUser,
    getOrdersReportByUser: GetOrdersReportByUser,
    getDispatchesReportByUser: GetDispatchesReportByUser,
    /* currentEmployeeActivityType: CurrentEmployeeActivityType,
    todaySummary: TodaySummary,
    todayFeed: TodayFeed,
    monthlySummary: MonthlySummary,
    weeklySummary: WeeklySummary, */
    getDistance: GetDistance,
    getGeolocation: GetGeoLocation,
    getRemoteDispatchesForOrder: GetRemoteDispatchesForOrder,
    getRemoteDispatches: GetRemoteDispatches,
    getLoadBoardForOrder: GetLoadBoardForOrder
  },
  mutations: {
    updateUserLeadSchedule: UpdateUserLeadSchedule,
    updateUserAccess: UpdateUserAccess,
    updateUserProfile: UpdateUserProfile,
    resolveInvitationLink: ResolveInvitationLink,
    inviteUser: InviteUser,
    activateUser: ActivateUser,
    deactivateUser: DeactivateUser,
    createUploadForm: CreateUploadForm,
    attachFileToQuote: AttachFileToQuote,
    updateStatus: UpdateStatus,
    createStatus: CreateStatus,
    deleteStatus: DeleteStatus,
    createEmailTemplate: CreateEmailTemplate,
    updateEmailTemplate: UpdateEmailTemplate,
    deleteEmailTemplate: DeleteEmailTemplate,
    createSMSTemplate: CreateSMSTemplate,
    updateSMSTemplate: UpdateSMSTemplate,
    deleteSMSTemplate: DeleteSMSTemplate,
    runTransportAutoQuoter: RunTransportAutoQuoter,
    createQuote: CreateQuote,
    updateQuote: UpdateQuote,
    duplicateQuote: DuplicateQuote,
    sendQuoteEmail: SendQuoteEmail,
    sendTermsAndConditionsEmail: SendTermsAndConditionsEmail,
    sendBillingInfoInputEmail: SendBillingInfoInputEmail,
    sendQuoteSMS: SendQuoteSMS,
    addQuoteNote: AddQuoteNote,
    updateQuoteNote: UpdateQuoteNote,
    deleteQuoteNote: DeleteQuoteNote,
    resolveBookOrderLink: ResolveBookOrderLink,
    resolveOrderSurveyLink: ResolveOrderSurveyLink,
    resolveTermsAndConditionsLink: ResolveTermsAndConditionsLink,
    resolveBillingInformationLink: ResolveBillingInformationLink,
    acceptTermsAndConditions: AcceptTermsAndConditions,
    provideBillingInfo: ProvideBillingInfo,
    submitCustomerSurvey: SubmitCustomerSurvey,
    createOrder: CreateOrder,
    updateOrder: UpdateOrder,
    batchUpdateOrders: BatchUpdateOrders,
    batchUpdateQuotes: BatchUpdateQuotes,
    postToLoadBoard: PostToLoadBoard,
    removeFromLoadBoard: RemoveFromLoadBoard,
    duplicateOrder: DuplicateOrder,
    convertToOrder: ConvertToOrder,
    convertToQuote: ConvertToQuote,
    createPricingException: CreatePricingException,
    updatePricingException: UpdatePricingException,
    updatePricingExceptions: UpdatePricingExceptions,
    updateVehicleSizechart: UpdateVehicleSizechart,
    deleteVehicleSizechart: DeleteVehicleSizechart,
    updateVehicleSize: UpdateVehicleSize,
    addCarrier: AddCarrier,
    updateCarrier: UpdateCarrier,
    addDriver: AddDriver,
    updateDriver: UpdateDriver,
    setBillingInfoToOrder: SetBillingInfoToOrder,
    chargeOrder: ChargeOrder,
    dispatchOrder: DispatchOrder,
    updateQuoteByCustomer: UpdateQuoteByCustomer,
    updateMileagePricings: UpdateMileagePricings,
    deleteMileagePricings: DeleteMileagePricings,
    updateDistanceFees: UpdateDistanceFees,
    deleteDistanceFees: DeleteDistanceFees,
    createReferrer: CreateReferrer,
    updateReferrer: UpdateReferrer,
    deleteReferrer: DeleteReferrer,
    setPhoneNumber: SetPhoneNumber,
    markNotificationAsRead: MarkNotificationAsRead,
    markTodayNotificationsAsRead: MarkTodayNotificationsAsRead,
    markEarlierNotificationsAsRead: MarkEarlierNotificationsAsRead,
    updateShortCodes: UpdateShortCodes,
    deleteShortCodes: DeleteShortCodes,
    updateMarketing: UpdateMarketing,
    createMarketing: CreateMarketing,
    deleteMarketing: DeleteMarketing
  }
};
